<template>
    <div>
        <modal :close="closeModal" :show="showModal">
            <template v-slot:header>
                <h1 class="header">{{ $t("modal.session-timeout.header") }} </h1>
            </template>

            <template v-slot:body>
                <div class="body-text"> {{ $t("modal.session-timeout.body1") }} </div>
                <div class="body-text"> {{ $t("modal.session-timeout.body2") }} </div>
            </template>

            <template v-slot:footer>
                <div class="text-right">
                    <button class="yes-button" @click="closeModal(false)">Yes</button>
                    <button class="no-button" @click="closeModal(true)">No</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal";
    import { sessionService } from "@/service"
    import FinishType from "@/model/apply/FinishType"

    export default {
        name: "SessionTimeoutModal",
        components: {
            Modal
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            closeModal: function(clearSession) {
                if (clearSession === true) {
                    sessionService.clearSession(FinishType.CANCEL);
                } else {
                    sessionService.resetSessionTimeout()
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .header {
        padding-top: rem(24px);
        padding-bottom: rem(16px);
        font-style: normal;
        font-weight: 600;
        font-size: rem(26px);
        line-height: rem(32px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    .body-text {
        font-weight: 400;
        font-size: rem(18px);
        color: $grey-darken-2;
        line-height: rem(28px);
    }

    .yes-button {
        float: right;
        font-size: rem(18px);
        margin: 0px 8px;
        color: $secondary-color;
        width: 31px;
        height: 20px;
    }

    .no-button {
        float: right;
        font-size: rem(18px);
        margin: 0px 8px;
        width: 25px;
        height: 20px;
    }
</style>
